import {Record, List} from 'immutable';

const Inquiry = Record({
    inquiryId: '',
    institutionId: '',
    childId: '',
    createdAt: '',
    reason: '',
    note: '',
    source: '',
    bookingSource: '',
    bookingNote: '',
    status: '',
    lostReason: '',
    lostCategory: '',
    actions: List(),
    child: null,
    plans: null,
    relations: List(),
    groupId: undefined,
    fte: null,
});

const InquiryAction = Record({
    inquiryActionId: '',
    inquiryId: '',
    createdBy: '',
    createdAt: '',
    due: '',
    lastUpdatedAt: '',
    lastUpdatedBy: '',
    note: '',
    subject: '',
    type: '',
});

function fromAPI(inquiryData) {
    return new Inquiry({
        ...inquiryData,
        actions: List(
            inquiryData.actions.map(
                action =>
                    new InquiryAction({
                        ...action,
                    }),
            ),
        ),
    });
}

const toAPI = inquiry => inquiry.toJS();

export default {
    record: Inquiry,
    default: new Inquiry(),
    fromAPI,
    toAPI,
};
